import { EmojiResource } from '@atlaskit/emoji/resource';

import { getEmojiProviderConfig } from './utils';

// In-memory store of emoji resources previous constructed.
// Key: cloudId (undefined is the base resource)
// Value: EmojiResource
const emojiCloudIdToResourceMap: Map<string | undefined, EmojiResource> = new Map<
	string,
	EmojiResource
>();

export const getEmojiResource = async (cloudId?: string): Promise<EmojiResource> => {
	const existingResource = emojiCloudIdToResourceMap.get(cloudId);

	if (existingResource) {
		return existingResource;
	}

	const newConfig = getEmojiProviderConfig(cloudId);
	const resource = new EmojiResource(newConfig);

	emojiCloudIdToResourceMap.set(cloudId, resource);

	return resource;
};
